<template>
    <div>
        Esta es la pagina de pruebas
        <b-row>
            <b-col cols="6">
                <app-web-cam :multiple="false" />
            </b-col>
        </b-row>
        
    </div>
</template>
<script>
import WebCam from '../UI/Controls/WebCam/WebCam.vue';
export default {
    name: 'WebCamPage',
    components: {
        appWebCam: WebCam
    },
    data() {
        return {
            
        }
    }
}
</script>